import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
     name: 'apiasset',
})
export class ApiassetPipe implements PipeTransform {
     transform(value: any, args?: any): any {
          if (value === null || value === undefined) {
               return '';
          } else if (value.match(/http(s)?:\/\//g)) {
               return value;
          }
          return window.app.api2 + value;
     }
}
